import React from 'react'

class DesignerIssueType extends React.Component {
  constructor(props){
    super(props)
    this.state = {value: this.props.pubIssueId}

    this.handleChange = this.handleChange.bind(this)
    this.select = React.createRef();
  }

  componentDidMount(){
    this.selector = $(`.${this.select.current.className}`).selectize();
    this.selector[0].selectize.on('change', this.handleChange);
  }

  componentWillUnmount(){
   this.selector[0].selectize.off('change', this.handleChange);
  }

  handleChange(selected) {
    this.props.onIssueChange(selected)
  }

  render() {
    return (
      <div className="card-block px-3 pt-3 pb-0">
        { this.props.notice &&
          <div className="d-flex flex-row">
            <p className="black-text">{this.props.notice}</p>
          </div>
        }
        <div className="d-flex flex-row md-form">
          <div className="w-100">
            <select ref={this.select} className="js-select" value={this.state.value} onChange={this.handleChange}>
              { this.props.issues.map((issueArr, key) =>
                <option key={key} value={issueArr[1]}>{issueArr[0]}</option>
              )}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

export default DesignerIssueType
